<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>日语资源管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 查询 -->
    <div class="content">
      <el-form
        inline
        :model="query"
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList()"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>

        <el-form-item label="资源状态" label-width="80px">
          <el-select
            v-model="query.state"
            clearable
            placeholder="请选择状态"
            @change="stateClick()"
          >
            <el-option
              v-for="item in statelist"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="来源"
          label-width="80px"
          style="margin-left: -15px"
        >
          <el-cascader
            :options="sourselist"
            v-model="selectedOrigion"
            clearable
            change-on-select
            filterable
            :props="{ value: 'name', label: 'name', checkStrictly: true }"
            style="width: 180px"
            placeholder="请选择来源"
            @change="stateClick"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="顾问" label-width="80px">
          <DeptRoleTeacherSelect v-model="query.adviserID" dept="日语" placeholder="请选择部门 → 角色 → 老师" @change="datelClick()" />
        </el-form-item>
        <el-form-item label="营销" label-width="80px">
          <DeptRoleTeacherSelect v-model="query.marketID" dept="日语" placeholder="请选择部门 → 角色 → 老师" @change="datelClick()" />
        </el-form-item>
        <el-form-item label="学历" label-width="60px">
          <el-select v-model="query.eduBack" clearable filterable placeholder="请选择" @change="selList()">
            <el-option v-for="item in edubacklist" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所在地" label-width="70px">
          <el-select v-model="query.province" clearable filterable placeholder="请选择" @change="selList()">
            <el-option v-for="item in provinceList" :label="item.areaName" :value="item.areaName" :key="item.areaID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学生/家长" label-width="80px">
          <el-select v-model="query.studentType" clearable placeholder="请选择" @change="selList()">
            <el-option v-for="item in studentTypeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学习目的" label-width="80px">
          <el-select v-model="query.purpose" clearable filterable placeholder="请选择" @change="selList()">
            <el-option v-for="item in purposeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上课形式" label-width="80px">
          <el-select v-model="query.intendedForm" clearable placeholder="请选择" @change="selList()">
            <el-option v-for="item in intendedFormList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <div>
          <el-form-item
            label="添加时间"
            label-width="80px"
            style="margin-left: 8px"
          >
            <el-date-picker
              v-model="query.daterange"
              @change="datelClick()"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="selList()">查询</el-button>
            <!-- <el-button
              type="success"
              v-if="userIsMarket == false"
              @click="addClick()"
              >新增</el-button
            > -->
            <el-button type="success" @click="exportClick()">导出</el-button>
          </el-form-item>
        </div>
      </el-form>

      <!-- 主体 -->
      <el-card class="box-card table">
        <div class="clearfix" slot="scope">
          <span>日语资源列表</span>
        </div>
        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width: 100%"
          @sort-change="sortChange"
          @filter-change="filterTag"
          :row-class-name="tableRowClassName"
        >
          <el-table-column prop="jpInputTime" label="添加时间"></el-table-column>
          <el-table-column prop="realName" label="姓名"></el-table-column>
          <el-table-column prop="wechat" label="微信"></el-table-column>
          <el-table-column prop="eduBack" label="学历"></el-table-column>
          <!-- 2026-01升级：新增字段 -->
          <el-table-column prop="japaneseBase" label="日语基础" :width="100"></el-table-column>
          <el-table-column
            prop="intendedCourse"
            label="意向课程"
          ></el-table-column>
          <el-table-column label="学习目的" :width="120">
            <template slot-scope="scope">{{ scope.row.learningPurpose || scope.row.purpose || '—' }}</template>
          </el-table-column>
          <el-table-column label="学生/家长" :width="100">
            <template slot-scope="scope">
              <el-tag type="primary" v-if="(scope.row.studentType || scope.row.StudentType) === '家长'">家长</el-tag>
              <el-tag type="warning" v-else-if="(scope.row.studentType || scope.row.StudentType) === '学生'">学生</el-tag>
              <span v-else>{{ scope.row.studentType || scope.row.StudentType || '—' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="areaShow" label="地区" :width="150"></el-table-column>
          <el-table-column prop="abroadDate" label="赴日时间" :width="100"></el-table-column>
          <el-table-column prop="intendedForm" label="意向形式" :width="120"></el-table-column>
          
          <el-table-column
            label="营销老师"
            v-if="userIsAdviser || userIsAdmain"
          >
            <template slot-scope="scope">{{ scope.row.marketName }}</template>
          </el-table-column>
          <el-table-column label="顾问老师" min-width="90">
            <template slot-scope="scope">{{ scope.row.adviserName || '—' }}</template>
          </el-table-column>
          <el-table-column label="来源">
            <template slot-scope="scope">
              <span :title="scope.row.origin">{{ scope.row.origin }}</span>
              <span :title="scope.row.recName">{{ scope.row.recName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="jpStatus" label="资源状态"></el-table-column>
          <el-table-column prop="summaryCombined" label="跟进详情" min-width="140" width="200" class-name="follow-combined-cell">
            <template slot-scope="scope">
              <span class="cell-wrap-pre" :title="scope.row.summaryCombined || scope.row.summary">{{ scope.row.summaryCombined || scope.row.summary || '—' }}</span>
            </template>
          </el-table-column>
          <!-- 留学=primary 日语=success 鸣野=warning；留学s=已签约(研究生) 其他=跟进中 无=待分配 -->
          <el-table-column label="跟进状态" :width="150">
            <template slot-scope="scope">
              <OtherDeptFollow :row="scope.row" :show-jap="false" @show-follow="showFollowDialog" />
            </template>
          </el-table-column>
          <el-table-column label="回访1" width="100">
            <template slot-scope="scope">
              <span class="link-like" @click="showVisitDetail(scope.row, 1)">{{ hasVisit1(scope.row) ? '已回访' : '未回访' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="回访2" width="100">
            <template slot-scope="scope">
              <span class="link-like" @click="showVisitDetail(scope.row, 2)">{{ hasVisit2(scope.row) ? '已回访' : '未回访' }}</span>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button-group v-if="showLimitedOpJap(scope.row)">
                <el-tooltip content="查看详情" placement="top">
                  <el-button type="success" size="mini" icon="el-icon-view"
                    @click="japshowstuid = scope.row.studentID"></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button type="info" size="mini" icon="el-icon-user-solid"
                    @click="assignClick(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
              <el-button-group v-else>
                <el-tooltip content="查看详情" placement="top">
                  <el-button type="success" size="mini" icon="el-icon-view"
                    @click="japshowstuid = scope.row.studentID"></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button type="info" size="mini" icon="el-icon-user-solid"
                    @click="assignClick(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="编辑" placement="top" v-if="canEditJap(scope.row)">
                  <el-button type="primary" size="mini" icon="el-icon-edit"
                    @click="editClick(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="margin-top: 20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 其他部门跟进详情弹窗（统一组件） -->
    <FollowDetailDialog :visible.sync="followDialogVisible" :type="followType" :row="followDialogRow" />

    <!-- 分配弹框（日语板块：可分配留学、鸣野，不显示分配给日语） -->
    <AssignResourceDialog
      :visible.sync="assignDialogVisible"
      :form="assignForm"
      :adviser-list="adviserlist"
      :market-list="marketlist"
      :user-is-admain="userIsAdmain"
      :show-student="true"
      :show-jap="false"
      :show-mingye="true"
      name-label="资源名称"
      empty-message="请选择分配给留学或鸣野"
      @success="getList"
    />

    <!-- 添加或修改弹框 -->
    <el-dialog
      :title="form.id > 0 ? '编辑日语资源' : '添加日语资源'"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm(form)"
      >
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item
              label="添加时间"
              prop="jpInputTime"
              :rules="[{ required: true, message: '不能为空' }]"
            >
              <el-date-picker
                v-model="form.jpInputTime"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                type="date"
                placeholder="选择时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item
              label="姓名"
              prop="realName"
              :rules="[{ required: true, message: '请输入姓名' }]"
            >
              <el-input
                v-model="form.realName"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item
              label="性别"
              prop="sex"
              :rules="[{ required: true, message: '请输选择性别' }]"
            >
              <el-radio-group v-model="form.sex">
                <el-radio :label="true">男</el-radio>
                <el-radio :label="false">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item
              label="资源状态"
              prop="japState"
              :rules="[{ required: true, message: '不能为空' }]"
            >
              <el-select
                v-model="form.japState"
                clearable
                placeholder="请选择资源状态"
                filterable
              >
                <el-option
                  v-for="item in statelist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item
              label="学历"
              prop="eduBack"
              :rules="[{ required: true, message: '不能为空' }]"
            >
              <el-select
                v-model="form.eduBack"
                clearable
                placeholder="请选择学历"
                filterable
              >
                <el-option
                  v-for="item in edubacklist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          label="退出费用"
          prop="exitAmount"
          v-if="form.jpStatus == 'f'"
        >
          <el-input
            v-model.number="form.exitAmount"
            type="number"
            placeholder="请输入数字"
          ></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item
              label="地区"
              :rules="[{ required: false, message: '不能为空' }]"
            >
              <el-cascader
                :options="areaList"
                v-model="selectedOptions"
                style="width: 100%"
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="学习目的" prop="purpose">
              <el-select
                v-model="form.purpose"
                clearable
                placeholder="请选择学习目的"
                filterable
              >
                <el-option
                  v-for="item in purposelist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item prop="wechat" label="微信">
              <el-input
                v-model="form.wechat"
                placeholder="请输入微信"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="qq" label="QQ">
              <el-input v-model="form.qq" placeholder="请输入QQ"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-alert type="warning" style="position: relative; top: -10px" v-if="form.wechatCheck">{{ form.wechatCheck }}</el-alert>
        <el-row :gutter="20">
          <el-col :span="10">
          <el-form-item label="学生/家长" prop="studentType">
            <el-select v-model="form.studentType" clearable placeholder="请选择" style="width:100%">
              <el-option v-for="item in studentTypeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="japanese" label="日语状态">
              <el-select
                v-model="form.japanese"
                clearable
                placeholder="请选择日语状态"
              >
                <el-option
                  v-for="item in japlist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="来源" prop="origin">
              <el-select
                v-model="form.origin"
                clearable
                placeholder="请选择来源"
                filterable
                @change="changeReouce"
                style="width: 100%"
              >
                <el-option
                  v-for="item in sourselist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="推荐人" prop="recName" v-if="currentOriginName == '留学组推荐' || currentOriginName == '日语组推荐'">
          <el-select v-model="form.recName" placeholder="请选择" filterable clearable style="width: 100%">
            <el-option v-for="item in adviserlist" :label="item.realName" :value="item.realName" :key="item.userID"></el-option>
          </el-select>
        </el-form-item>
        <!-- 来源下一层：抖音=直播/短视频，小红书=账号来源等，数据来自 GetStuParam 的 originParam[].children -->
        <el-form-item :label="currentOriginName == '小红书' ? '小红书' : labelorgin" prop="recName" v-if="ischildren && subOriginOptions.length > 0">
          <el-select v-model="form.recName" placeholder="请选择" filterable clearable style="width: 100%">
            <el-option v-for="item in subOriginOptions" :label="item.name" :value="item.name" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电话" prop="mobile">
          <el-input
            v-model.number="form.mobile"
            type="number"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>

        <!-- <el-form-item prop="intendedCourse" label="意向课程">
          <el-select
            v-model="courseOptions"
            placeholder="请选择意向课程"
            multiple
            clearable
            :rules="[{ required: true, message: '不能为空' }]"
            style="width: 100%"
          >
            <el-option
              v-for="item in courselist"
              :label="item.name"
              :value="item.name"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item prop="intendedCourse" label="意向课程">
              <el-input
                v-model="form.intendedCourse"
                placeholder="请输入意向课程"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="意向形式" prop="intendedForm">
              <el-select
                v-model="form.intendedForm"
                clearable
                placeholder="请选择意向形式"
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in intendedFormList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item prop="suumary" label="跟进情况">
          <el-input
            v-model="form.summary"
            placeholder="请输入跟进情况"
          ></el-input>
        </el-form-item>

        <div>
          <el-divider content-position="left" style="padding: 10px 0px">修改顾问/营销老师</el-divider>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item
                label="顾问老师"
                prop="adviserID"
                :rules="[{ required: true, message: '请选择' }]"
              >
                <DeptRoleTeacherSelect v-model="form.adviserID" dept="日语" placeholder="请选择部门 → 角色 → 老师" />
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="营销老师" prop="marketID">
                <DeptRoleTeacherSelect v-model="form.marketID" dept="日语" placeholder="请选择部门 → 角色 → 老师" />
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit"
            >提交</el-button
          >
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <VisitDetailDialog
      :visible.sync="visitDetailVisible"
      :row="visitDetailRow"
      :which-visit="visitDetailWhich"
      follow-type="jap"
      @success="getList"
      @closed="onVisitDetailClosed"
    />

    <JapaneseShow
      :japstuid="japshowstuid"
      v-on:japsetzero="japshowstuid = 0"
    ></JapaneseShow>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import user from "@/plugins/user.js";
import { buildJapSubmitPayload } from "@/plugins/japFormHelper.js";
import JapaneseShow from "@/components/JapaneseShow";
import OtherDeptFollow from "@/components/OtherDeptFollow";
import FollowDetailDialog from "@/components/FollowDetailDialog";
import VisitDetailDialog from "@/components/VisitDetailDialog";
import DeptRoleTeacherSelect from "@/components/DeptRoleTeacherSelect.vue";
import AssignResourceDialog from "@/components/AssignResourceDialog";
export default {
  data() {
    return {
      userIsAdmain: user.isAdmin(), //管理员
      userIsAdviser: user.isAdviser(), //顾问老师
      userIsMarket: user.isMarket(), //营销老师
      query: {},
      form: {},
      dialogVisible: false,
      viewDialogVisible: false,
      submiting: false,
      loading: false,
      tableData: [],
      total: 0,
      currentPage4: 1,
      pageSize: 10,
      sourselist: [], //来源（树形，含下一层）
      selectedOrigion: [], // 筛选用：一级来源 + 二级（如抖音→直播）
      ischildren: false,
      labelorgin: '',
      subOriginOptions: [], // 当前来源的次级选项（如抖音的直播/短视频、小红书的账号来源）
      currentOriginName: '', // 当前选中的来源名称，用于显示推荐人/下一层 label
      edubacklist: url.getEduBack(), //学历
      studentTypeList: url.getStudentTypeList(), //学生/家长
      provinceList: [], //省份列表
      purposeList: url.getPurposeList(), //学习目的（筛选用）
      intendedFormList: url.getIntendedFormList(), //意向上课形式（筛选用）
      japlist: url.getJapLevelList(), // 日语水平（与鸣野统一）
      statelist: url.getStateData(), //资源状态
      purposelist: [
        { id: "兴趣", name: "兴趣" },
        { id: "留学", name: "留学" },
        { id: "就职", name: "就职" },
        { id: "高考日语", name: "高考日语" },
        { id: "考研辅导", name: "考研辅导" },
        { id: "在日升学", name: "在日升学" },
      ], //学习目的（表单用）
      courselist: [], //意向课程
      courseOptions: [],
      areaList: [], //地区
      selectedOptions: [],
      marketlist: [], //营销老师
      adviserlist: [], //顾问老师
      documentlist: [], //文案老师
      japshowstuid: 0,
      assignDialogVisible: false, //分配对话框显示
      assignForm: {
        resourceTypes: [] // 分配的资源类型：['鸣野']
      }, //分配表单
      visitDetailVisible: false,
      visitDetailRow: null,
      visitDetailWhich: 1,
      followDialogVisible: false,
      followDialogLoading: false,
      followType: '',
      followDialogRow: null,
      followData: { list: [] },
      followMingyeDetail: null,
      followDialogTitle: '',
    };
  },
  methods: {
    wechatChange() {
      var _this = this;
      var wechat = this.form.wechat;
      if (!wechat) {
        _this.$set(_this.form, "wechatCheck", "");
        return;
      }
      $.get(url.getStu("CheckWechatDuplicate"), {
        wechat: wechat,
        isStudent: false,
        isJap: true,
        isMingye: false,
        excludeId: this.form.studentID || 0
      }, (data) => {
        if (data.hasDuplicate && data.items && data.items.length > 0) {
          var msg = "资源重复！";
          data.items.forEach(function(it) {
            msg += " 【" + it.blockName + "】跟进顾问：" + (it.adviserName || "-") + "，营销：" + (it.marketName || "-") + "，录入时间：" + (it.inputTime || "-");
          });
          _this.$set(_this.form, "wechatCheck", msg);
        } else {
          _this.$set(_this.form, "wechatCheck", "");
        }
      });
    },
    canEditJap(row) {
      return user.canEditJap(row);
    },
    isMarketingOnlyJap(row) {
      return user.isMarketingOnlyJap(row);
    },
    isNoAdviserJap(row) {
      return user.isNoAdviserJap(row);
    },
    showLimitedOpJap(row) {
      return user.showLimitedOpJap(row);
    },
    openJapFollow(studentID) {
      if (studentID && typeof window !== 'undefined' && window.open) {
        window.open('/vue/japfollow?id=' + studentID, '_blank');
      }
    },
    hasVisit1(row) {
      if (!row) return false;
      const d = row.visit1Date || row.Visit1Date;
      const s = row.visit1Subject || row.Visit1Subject;
      const sum = row.visit1Summary != null ? row.visit1Summary : (row.Visit1Summary != null ? row.Visit1Summary : '');
      return (d != null && d !== '') || (s != null && String(s).trim() !== '') || (sum != null && String(sum).trim() !== '');
    },
    hasVisit2(row) {
      if (!row) return false;
      const d = row.visit2Date || row.Visit2Date;
      const s = row.visit2Subject || row.Visit2Subject;
      const sum = row.visit2Summary != null ? row.visit2Summary : (row.Visit2Summary != null ? row.Visit2Summary : '');
      return (d != null && d !== '') || (s != null && String(s).trim() !== '') || (sum != null && String(sum).trim() !== '');
    },
    showVisitDetail(row, whichVisit) {
      this.visitDetailRow = row;
      this.visitDetailWhich = whichVisit === 2 ? 2 : 1;
      this.visitDetailVisible = true;
    },
    // 回访弹窗关闭后的后续：清理行引用并确保 loading 关闭（与 getList 联动）
    onVisitDetailClosed() {
      this.visitDetailRow = null;
      this.visitDetailWhich = 1;
      this.loading = false;
    },
    //行样式
    tableRowClassName({ row, rowIndex }) {
      if (row.state === "c") {
        return "success-row";
      } else if (row.state === "e") {
        return "info-row";
      }
      return "";
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //   排序
    sortChange: function (sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      this.getList();
    },
    // 筛选
    filterTag: function (filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      this.getList();
    },
    // 按状态查询
    stateClick: function () {
      this.getList();
    },
    // 按时间
    datelClick: function () {
      this.getList();
    },
    //   意向课程
    getCourseList: function () {
      var _this = this;
      var link = url.getJap("getall_course");
      $.get(link, {}, (data) => {
        _this.courselist = data;
      });
    },
    // 营销/顾问老师：不再按板块获取，直接获取所有启用用户
    getTeacherList: function () {
      var _this = this;
      $.get(url.getStu("getenableusers"), {}, (data) => {
        var list = data || [];
        _this.marketlist = list;
        _this.adviserlist = list;
      });
    },
    // 地区
    getAreaList: function () {
      var _this = this;
      var link = url.getCommon("getareatwo");
      $.getJSON(link, (data) => {
        _this.areaList = data;
      });
    },
    // 省份列表（筛选用）
    getProvinceList() {
      var _this = this;
      var link = url.getCommon("getareabyname");
      $.get(link, {}, (data) => {
        _this.provinceList = data || [];
      });
    },
    // 来源
    getAllOrigin() {
      var _this = this;
      var link = url.getCommon("GetStuParam");
      $.get(link, {}, (data) => {
        _this.sourselist=data.originParam;
      });
    },
    //   列表
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = Object.assign({}, _this.query);
      if (_this.query.daterange) {
        params.start = _this.query.daterange[0];
        params.end = _this.query.daterange[1];
      } else {
        params.start = "";
        params.end = "";
      }
      if (_this.selectedOrigion && _this.selectedOrigion.length > 0) {
        params.origin = _this.selectedOrigion[0] || "";
        params.recName = _this.selectedOrigion[1] || "";
      } else {
        params.origin = "";
        params.recName = "";
      }
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      delete params.daterange;
      var link = url.getJap("getlist_base");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    // 查询
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    // 新增
    addClick: function () {
      this.dialogVisible = true;
      var now = new Date();
      var today =
        now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate();
      //表单重置
      this.form = {
        sex: true,
        jpInputTime: today,
        isAbove:true,
      };
      //地区选择重置
      this.selectedOptions = [];
    },
    // 编辑
    showFollowDialog: function(type, row) {
      this.followType = type;
      this.followDialogRow = row && row.studentID != null ? { ...row, id: row.studentID } : (row || {});
      this.followDialogVisible = true;
    },
    viewStudentFollow: function(studentID) {
      if (studentID) window.open('/vue/follow?id=' + studentID, '_blank');
    },
    viewMingyeFollow: function(studentID) {
      if (studentID) window.open('/vue/mingyefollow?id=' + studentID, '_blank');
    },
    getStateName: function(state) {
      return state ? '跟进中' : '待分配';
    },
    editClick: function (row) {
      if (!row) return;
      console.log(row.studentID);
      
      var _this = this;
      var studentID = row.studentID;
      var link = url.getJap("getmodel_base");
      $.get(link, { studentID: studentID }, (data) => {
        if (!data || data.status === 0) {
          _this.$message({ type: "error", message: (data && data.msg) || "获取资源详情失败" });
          return;
        }
        _this.form = data;
        _this.form.studentID = data.studentID || data.StudentID || studentID;
        _this.form.jpInputTime = data.jpInputTime || data.inputTime || row.jpInputTime || "";
        _this.form.japState = data.japState || data.JapState || row.jpStatus || row.japState || "";
        _this.dialogVisible = true;
        _this.selectedOptions = [];
        var provinceID = data.provinceID != null ? data.provinceID : row.provinceID;
        var cityID = data.cityID != null ? data.cityID : row.cityID;
        if (provinceID != null) _this.selectedOptions.push(provinceID);
        if (cityID != null) _this.selectedOptions.push(cityID);
        _this.$nextTick(function() { _this.changeReouce(_this.form.origin); });
      });
    },
    // 来源变化：若当前来源在 originParam 中配置了 children（如抖音、小红书下一层），则显示次级下拉
    changeReouce(val) {
      if (val == null || val === '') {
        this.ischildren = false;
        this.subOriginOptions = [];
        this.currentOriginName = '';
        this.labelorgin = '';
        return;
      }
      const index = this.sourselist.findIndex(item => item.id == val || item.name === val);
      if (index >= 0) {
        this.currentOriginName = this.sourselist[index].name || '';
        this.labelorgin = this.currentOriginName;
        if (this.sourselist[index].children && this.sourselist[index].children.length > 0) {
          this.ischildren = true;
          this.subOriginOptions = this.sourselist[index].children;
        } else {
          this.ischildren = false;
          this.subOriginOptions = [];
        }
      } else {
        this.ischildren = false;
        this.subOriginOptions = [];
        this.currentOriginName = '';
        this.labelorgin = '';
      }
    },
    // 提交
    submitForm: function (formName) {
      var _this = this;
      var link = url.getJap("addorupdate_base");
      var info = buildJapSubmitPayload(this.form);
      info.studentID = info.studentID || info.StudentID || this.form.studentID;
      info.japState = info.japState || info.JapState;
      info.provinceID = this.selectedOptions[0];
      info.cityID = this.selectedOptions[1];

      //info.intendedCourse = this.courseOptions.join();

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 导出（与列表同筛选，调用学生跟进列表导出接口）
    exportClick: function () {
      var _this = this;
      var params = Object.assign({}, _this.query);
      if (_this.query.daterange && _this.query.daterange.length >= 2) {
        params.start = _this.query.daterange[0];
        params.end = _this.query.daterange[1];
      }
      if (_this.selectedOrigion && _this.selectedOrigion.length > 0) {
        params.origin = _this.selectedOrigion[0] || "";
        params.recName = _this.selectedOrigion[1] || "";
      } else {
        params.origin = "";
        params.recName = "";
      }
      delete params.daterange;
      delete params.pagesize;
      delete params.pageindex;
      var result = [];
      for (var item in params) {
        if (params[item] !== undefined && params[item] !== "" && params[item] !== null) {
          result.push(item + "=" + encodeURIComponent(params[item]));
        }
      }
      var link = url.getJap("exportjapbase") + "?" + result.join("&");
      window.open(link, "_blank");
    },
    // 分配
    assignClick: function(row) {
      if (!row) return;
      var _this = this;
      _this.assignForm = {
        studentID: row.studentID,
        realName: row.realName,
        isStudent: row.isStudent || false,
        isJap: true, // 当前是日语列表
        isMingye: row.isMingye || false,
        resourceTypes: [],
        adviserID: row.adviserID || null,
        marketID: row.marketID || null,
        myAdviserID: row.myAdviserID || null,
        myMarketID: row.myMarketID || null
      };
      _this.assignDialogVisible = true;
    },
  },
  components: {
    JapaneseShow,
    OtherDeptFollow,
    FollowDetailDialog,
    VisitDetailDialog,
    AssignResourceDialog,
    DeptRoleTeacherSelect,
  },
  mounted() {
    // 来源
    this.getAllOrigin();
    //   意向课程
    this.getCourseList();
    // 营销/顾问老师（统一接口）
    this.getTeacherList();
    // 地区
    this.getAreaList();
    // 省份列表（筛选用）
    this.getProvinceList();
    // 列表
    this.getList();
  },
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-input,
.el-select {
  width: 100%;
}
.link-like { color: #409EFF; cursor: pointer; }
.link-like:hover { text-decoration: underline; }
.visit-block { margin-bottom: 16px; }
.follow-detail-block div { margin-bottom: 10px; line-height: 1.6; }
.visit-block .visit-label { font-weight: bold; margin-bottom: 8px; color: #303133; }
.visit-block div { margin-bottom: 4px; }
/* 跟进详情列：自动换行，原+回访1+回访2 各自换行 */
.cell-wrap-pre { white-space: pre-line; word-break: break-word; }
::v-deep .follow-combined-cell .cell { white-space: pre-line !important; word-break: break-word; }
</style>